import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styles from './dashboard-nav.module.scss';

type DashboardBalanceCardProps = {
  className?: string;
  onNavigate?: () => void;
};

function DashboardBalanceCard({
  className,
  onNavigate,
}: DashboardBalanceCardProps): JSX.Element {
  const { wallet, loading } = useSelector((state: any) => state.userStats);

  return (
    <section
      className={[styles.balanceCard, className].filter(Boolean).join(' ')}
      aria-label="QuickCam Credits balance"
    >
      <span>Your Balance:</span>
      <div className={styles.balanceAmountRow}>
        <strong>
          {loading ? 'Loading' : (wallet?.qcamCredit || 0).toLocaleString()}
        </strong>
        <span className={styles.balanceCreditsLabel}>
          <span className={`material-icons ${styles.creditsGlyph}`} aria-hidden>
            toll
          </span>
          QuickCam Credits
        </span>
      </div>
      <Link
        className={styles.buyCreditsLink}
        to="/u/quickcam-credits?purchase=1"
        onClick={() => onNavigate?.()}
      >
        <span className={`material-icons ${styles.buyCreditsLinkIcon}`} aria-hidden>
          toll
        </span>
        Buy QuickCam Credits
      </Link>
    </section>
  );
}

DashboardBalanceCard.defaultProps = {
  className: undefined,
  onNavigate: undefined,
};

export default DashboardBalanceCard;
